// assets/footer-drawer.js
class FooterDrawer extends DrawerElement {
  get shouldAppendToBody() {
    return false; // match CartDrawer behavior
  }
  connectedCallback() {
    super.connectedCallback();
  }
  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);
    if (this.open && window.theme?.a11y?.trapFocus) {
      theme.a11y.trapFocus(this, this.focusElement);
    }
  }
}

// Register only once
if (!customElements.get('footer-drawer')) {
  customElements.define('footer-drawer', FooterDrawer);
}
